import { isMobile } from '@/model/util/dom/domResponsive'

/**
 * 指定したidのボタンをクリックする
 * @param id クリックするid
 */
const buttonClick = (id: string) => {
  const ret = document.getElementById(id)
  if (ret) {
    ret.click()
  }
}

/**
 * 指定したidのformをsubmitする
 * @param id submitするid
 */
const submitById = (id: string) => {
  const ret = document.getElementById(id) as HTMLFormElement
  if (ret) {
    ret.submit()
  }
}

/**
 * 現在フォーカスしている要素からフォーカスを外す
 */
const focusBlur = () => {
  // モバイル版のみフォーカスを外す
  if (isMobile()) {
    ;(document.activeElement as HTMLElement).blur()
  }
}

export { buttonClick, submitById, focusBlur }
